export enum SkillStatus {
  Pending = "Pending",
  Approved = "Approved",
}
